import React from 'react';
export function ProgramsHeader() {
  return <div className="pt-32 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-1692">
      <div className="animate-fade-up-in" data-id="element-1693">
        <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6" data-id="element-1694">
          Our <span className="text-[#00D4FF]" data-id="element-1695">Programs</span>
        </h1>
        <p className="text-xl text-gray-300 max-w-3xl leading-relaxed" data-id="element-1696">
          From toddlers to adults, we have a martial arts curriculum designed to
          help you reach your full potential. Discover the perfect class for
          your age and skill level.
        </p>
      </div>
    </div>;
}